import React from 'react'

import { AgentDetails } from '@zet/customer'
import FormValidationErrorMessage from '@zet/customer/src/components/formValidationErrorMessage'
import {
  B1,
  B2,
  Icon,
  Input,
  InputGroup,
  Stack,
  colors,
} from '@zet/design-system'
import { i18n } from '@zet/localization'
import { Control, Controller, FieldErrors } from 'react-hook-form'

const InputFields = ({
  errors,
  control,
  agentData,
}: {
  errors: FieldErrors<{
    fullName: string
    phoneNumber: string
    pinCode: string
    advisorCode?: string | undefined
    email: string
  }>
  control: Control<{
    fullName: string
    phoneNumber: string
    pinCode: string
    advisorCode?: string | undefined
    email: string
  }>
  agentData: AgentDetails
}) => {
  const isMagnetFlow = agentData?.partnerId === 193
  return (
    <Stack className="px-3 pb-10 pt-2">
      <B2 className="text-grays-80 mt-2">
        {i18n.t('webFlow.nameAndPhoneNumber.yourName')}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            placeholder="Eg: Ankush Singh"
            onBlur={onBlur}
            onChangeText={onChange}
            value={value}
            type={`${errors?.fullName?.message ? 'error' : 'primary'}`}
            className="mt-1"
          />
        )}
        name="fullName"
      />
      <FormValidationErrorMessage
        error={errors?.fullName?.message}
        key={errors?.fullName?.message}
      />

      <B2 className="text-grays-80 mt-4">
        {i18n.t('webFlow.basicDetails.email')}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            placeholder="Eg: username@email.com"
            onBlur={onBlur}
            onChangeText={onChange}
            value={value}
            type={`${errors?.email?.message ? 'error' : 'primary'}`}
            className="mt-1"
          />
        )}
        name="email"
      />
      <FormValidationErrorMessage
        error={errors?.email?.message}
        key={errors?.email?.message}
      />

      <B2 className="text-grays-80 mb-1 mt-4">
        {i18n.t('webFlow.nameAndPhoneNumber.yourPhoneNumber')}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <InputGroup
            placeholder="900 000 0000"
            onBlur={onBlur}
            onChangeText={onChange}
            value={value}
            type={`${errors?.phoneNumber?.message ? 'error' : 'primary'}`}
            maxLength={10}
            keyboardType="number-pad"
          />
        )}
        name="phoneNumber"
      />
      <FormValidationErrorMessage
        error={errors.phoneNumber?.message}
        key={errors.phoneNumber?.message}
      />
      {!isMagnetFlow && (
        <>
          <B2 className="text-grays-80 mb-2 mt-4">
            {i18n.t('webFlow.basicDetails.pinCode')}
            <B1 className="text-error-100 pl-1">*</B1>
          </B2>
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                maxLength={6}
                iconLeft={
                  <Icon
                    type="LocationPointerOutlined"
                    color={colors.grays[50]}
                  ></Icon>
                }
                placeholder="Eg: 560035"
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                type={`${errors?.pinCode?.message ? 'error' : 'primary'}`}
                keyboardType="number-pad"
              />
            )}
            name="pinCode"
          />
          <FormValidationErrorMessage
            error={errors.pinCode?.message}
            key={errors.pinCode?.message}
          />
        </>
      )}

      {Boolean(agentData?.isDsa) && (
        <>
          <B2 className="text-grays-80 mb-1 mt-4">
            {i18n.t('webFlow.nameAndPhoneNumber.advisorCode')}
          </B2>
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                placeholder="001"
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                type={`${errors?.advisorCode?.message ? 'error' : 'primary'}`}
                className="mt-1"
              />
            )}
            name="advisorCode"
          />
          <FormValidationErrorMessage
            error={errors.advisorCode?.message}
            key={errors.advisorCode?.message}
          />
        </>
      )}
    </Stack>
  )
}

export { InputFields }
